import type { ReactNode } from "react";
import { GenericLabel } from "./GenericLabel";

type Props = {
  title?: ReactNode;
  imageUrl?: string;
};

export const CompetitionLabel = ({ title, imageUrl }: Props) => {
  return <GenericLabel title={title} imageUrl={imageUrl} avatarIcon="fa-trophy" />;
};
